import { styled } from '../../styles';

export const Video = styled('div', {
	video: {
		// border: '2px solid red',
		position: 'fixed',
		top: 0,
		right: 0,
		left: 0,
		bottom: 0,
		width: '100%',
		height: 'auto',
		minWidth: '100%',
		minHeight: '100%',
		objectFit: 'cover',
		zIndex: '1000',
	},

	canvas: {
		display: 'none',
	}
});

export const Container = styled('div', {
	position: 'fixed',
	top: 0,
	left: 0,
	right: 0,
	bottom: 0,
	minWidth: '100%',
	minHeight: '100%',

	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',

	'.logo': {
		marginBottom: '2.5rem',
	}
});


export const ScanMarker = styled('div', {
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',

	p: {
		color: '#fff',
		fontSize: '0.8rem',
		marginTop: '1.2rem',
	}
});
